import React, { useEffect, useState } from "react";
import { Card, Col, Label, Row } from "reactstrap";
import "assets/scss/website/app.scss";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "../../../../../../node_modules/react-toastify";
import FileUpload from "./file-upload/file-upload.component";
import { useTranslation } from "react-i18next";
import fileIcon from "../../../../../assets/images/website/createResale/file.png";
import zarfIcon from "../../../../../assets/images/website/createResale/zarf.png";
import signIcon from "../../../../../assets/images/website/createResale/sign.png";

const StepFour = (props) => {
	const [uploadState, setUploadState] = useState(false);
	const { goBackHandler, stateData, updateStateHandler, setModal } = props;
	const [upload, setUpload] = useState(false);

	const { t } = useTranslation();
	const [formData, setFormData] = useState({});

	useEffect(() => {
		setFormData({
			contracts_ids: stateData.contracts_ids,
			contractsIds: stateData.contractsIds,
			national_ids: stateData.national_ids,
			nationalIds: stateData.nationalIds,
			terms_and_conditions_ids: stateData.terms_and_conditions_ids,
			termsAndConditionsIds: stateData.termsAndConditionsIds,
			bank_account: stateData.bank_account,
			iban: stateData.iban,
			swift: stateData.swift,
		});
	}, [stateData]);

	const updatedAttachment = (attachments, type) => {
		const ids = attachments.map((res) => res.id);
		if (type === "national_ids") {
			setFormData({
				...formData,
				national_ids: [...formData.national_ids, ...ids],
				nationalIds: [...formData.nationalIds, ...attachments],
			});
		} else if (type === "contract_ids") {
			setFormData({
				...formData,
				contracts_ids: [...formData.contracts_ids, ...ids],
				contractsIds: [...formData.contractsIds, ...attachments],
			});
		} else {
			setFormData({
				...formData,
				terms_and_conditions_ids: [
					...formData.terms_and_conditions_ids,
					...ids,
				],
				termsAndConditionsIds: [
					...formData.termsAndConditionsIds,
					...attachments,
				],
			});
		}
	};

	// FILE UPLOAD
	const deleteAttachment = (Items, type) => {
		if (type === "national_ids") {
			let updatedMedia = formData.national_ids?.filter(
				(item) => item !== Items[0].id
			);
			let updatedNationalIds = formData.nationalIds?.filter(
				(item) => item.id !== Items[0].id
			);
			setFormData({
				...formData,
				national_ids: updatedMedia,
				nationalIds: updatedNationalIds,
			});
		} else if (type === "contract_ids") {
			let updatedMedia = formData.contracts_ids?.filter(
				(item) => item !== Items[0].id
			);
			let updatedContractIds = formData.contractsIds?.filter(
				(item) => item.id !== Items[0].id
			);
			setFormData({
				...formData,
				contracts_ids: updatedMedia,
				contractsIds: updatedContractIds,
			});
		} else {
			let updatedMedia = formData?.terms_and_conditions_ids?.filter(
				(item) => item !== Items[0].id
			);
			let updatedTermsIds = formData.termsAndConditionsIds?.filter(
				(item) => item.id !== Items[0].id
			);
			setFormData({
				...formData,
				terms_and_conditions_ids: updatedMedia,
				termsAndConditionsIds: updatedTermsIds,
			});
		}
	};
	const submitFormHandler = () => {
		if (formData?.national_ids.length === 0) {
			return toast.error(`${t("National Id images are required")}`);
		}
		if (formData?.contracts_ids.length === 0) {
			return toast.error(`${t("Contract images required")}`);
		}
		if (formData?.terms_and_conditions_ids.length === 0) {
			return toast.error(`${t("Terms and Conditions pdf are required")}`);
		}
		// if(/^[^0-9]+$/.test(formData.bank_account)){
		//     return toast.error("Account Number format invalid")
		// }
		// if(/[^a-zA-Z-0-9]/.test(formData.iban)){
		//     return toast.error("IBAN format invalid")
		// }
		// if(/[^a-zA-Z-0-9]+$/.test(formData.swift)){
		//     return toast.error("Swift Code format invalid")
		// }

		updateStateHandler(formData);
	};

	return (
		<AvForm onValidSubmit={() => submitFormHandler()} className="step-one">
			<p className="subtitle">{t("Add the location of your property")}</p>
			<Row className="mt-4 mb-2">
				<Col md={4}>
					<FileUpload
						accept=".jpg,.png,.jpeg"
						attachmentType="contract_ids"
						attachmentData={formData.contractsIds}
						updatedAttachment={updatedAttachment}
						deleteAttachment={deleteAttachment}
						multiple
						icon={fileIcon}
						setUpload={setUpload}
						setUploadState={setUploadState}
						text={t("click the icon to upload contract images")}
					/>
				</Col>
				<Col md={4}>
					<FileUpload
						accept=".jpg,.png,.jpeg,.JPG,.PNG,.JPEG"
						attachmentType="national_ids"
						attachmentData={formData.nationalIds}
						updatedAttachment={updatedAttachment}
						deleteAttachment={deleteAttachment}
						setUpload={setUpload}
						multiple
						icon={zarfIcon}
						setUploadState={setUploadState}
						text={t("click the icon to upload national ID images")}
					/>
				</Col>
				<Col md={4}>
					<FileUpload
						accept=".pdf,.doc,.docx,.jpg,.png,.jpeg,.JPG,.PNG,.JPEG"
						attachmentType="terms_and_conditions_ids"
						attachmentData={formData.termsAndConditionsIds}
						updatedAttachment={updatedAttachment}
						deleteAttachment={deleteAttachment}
						setUpload={setUpload}
						multiple
						icon={signIcon}
						setUploadState={setUploadState}
						text={t("click the icon to upload PDF with signature")}
					/>
				</Col>
			</Row>
			<div className="p-3">
				<label className="mb-4">Back Account Information</label>
				<Row>
					<Col md={4} className="mb-3">
						<AvField
							errorMessage={t("this field is required")}
							className="style-input"
							name={"iban"}
							label={t("IBAN Number (Optional)")}
							bsSize="lg"
							value={formData.iban}
							onChange={(e) => {
								setFormData({ ...formData, iban: e.target.value });
							}}
							placeholder={t("IBAN Number")}
							type="text"
						/>
					</Col>
					<Col md={4} className="mb-3">
						<AvField
							errorMessage={t("this field is required")}
							className="style-input"
							name={"swift"}
							label={t("Swift Code (Optional)")}
							bsSize="lg"
							value={formData.swift}
							onChange={(e) => {
								setFormData({ ...formData, swift: e.target.value });
							}}
							placeholder={t("Swift Code")}
							type="text"
						/>
					</Col>
					<Col md={4} className="mb-3">
						<AvField
							errorMessage={t("this field is required")}
							className="style-input"
							name={"bank_account"}
							label={t("Account Number (Optional)")}
							bsSize="lg"
							value={formData.bank_account}
							onChange={(e) => {
								setFormData({ ...formData, bank_account: e.target.value });
							}}
							placeholder={t("Account Number")}
							type="text"
						/>
					</Col>
				</Row>
			</div>
			<Row className="my-4">
				<Col md={9}>
					<button
						type="button"
						style={{ borderRadius: "5px", width: "15%" }}
						className="btn btn-light btnHeight cancel text-center"
						onClick={() => setModal(true)}>
						{t("Cancel")}
					</button>
				</Col>
				<Col md={3} className="d-flex justify-content-between">
					<button
						type="button"
						onClick={() => {
							updateStateHandler(formData);
							goBackHandler();
						}}
						className="btn btn-light btnHeight back text-center"
						style={{ borderRadius: "5px", width: "45%" }}>
						{t("Back")}
					</button>
					<button
						type="submit"
						style={{
							borderRadius: "5px",
							width: "45%",
							borderColor: "var(--primary-color)",
							background: "var(--primary-color)",
						}}
						className="btn btn-success btnHeight next text-center "
						disabled={upload}>
						{t("Next")}
					</button>
				</Col>
			</Row>
		</AvForm>
	);
};

export default StepFour;
